// extracted by mini-css-extract-plugin
module.exports = {"field":"checkbox__field--UQMK4","ripple":"checkbox__ripple--2gQV3","check":"checkbox__check--FZmU0","checked":"checkbox__checked--U7x_3"};